export enum HandOffType {
  HAND_TO_ME = 0,
  LEAVE_AT_DOOR = 1,
}

export const DELIVERY_HANDOFF_TYPE_DEFAULT = HandOffType.LEAVE_AT_DOOR;
